import { getRuntimeEnv } from "./runtimeEnv";
import { SupportedLocale } from "../i18n/locale";

// Os defaults são os valores de produção e precisam ser idênticos aos declarados em
// appPackage/production/manifest.json — a validação da loja exige "the same link in the
// app manifest and AppSource". As variáveis existem apenas para permitir override em
// outros ambientes sem rebuild da imagem.
export const appLinks = {
  privacy: getRuntimeEnv("REACT_APP_PRIVACY_URL") || "https://teams.utech.com.br/public/privacy",
  terms: getRuntimeEnv("REACT_APP_TERMS_URL") || "https://teams.utech.com.br/public/terms",
  support: getRuntimeEnv("REACT_APP_SUPPORT_URL") || "https://utech.com.br/site/suporte-tecnico/",
};

// As páginas de privacidade e termos respondem ao parâmetro `lang` (en, pt-BR e es), e
// caem para inglês em qualquer outro valor — por isso o locale do Teams pode ser repassado
// direto, sem tabela de conversão.
//
// Não aplicar à URL de suporte: aquela página ignora o parâmetro.
// Não aplicar ao manifest: ele é estático e a validação da loja exige que o link declarado
// nele seja idêntico ao do AppSource.
export function withLocale(url: string, locale: SupportedLocale): string {
  // URL/searchParams em vez de concatenar: hoje nenhuma dessas URLs tem query string, mas
  // concatenar quebraria em silêncio se um dia tiverem.
  const parsed = new URL(url);
  parsed.searchParams.set("lang", locale);
  return parsed.toString();
}
